
var find = function fn(list, id, index) {
  var rs = null;
  for (var i = 0; i < list.length; i++) {
    if (
      rs
    ) {
      return rs;
    }
    var el = list[i];
    if (
      el.value == id
    ) {
      if (
        !el.parent_label
      ) {
        rs = {
          dad: el.label
        };
        break;
      } else {
        rs = {
          dad: el.parent_label
          , sub: el.label
        };
        break;
      }
    }
    var children = el.children;
    rs = fn(children, id);
  }
  return rs;
}
export default {
  data() {
    return {
      nav: [
        {
          label: '首页', vaule: '-1', children: [
            {"value": 100, "label": "网站地图", parent_label: "首页", "children": []},
            {"value": 101, "label": "联系我们", parent_label: "首页", "children": []}
          ]
        },
        {
          "value": 15,
          "label": "关于协会",
          "children": [
            {"value": 26, "label": "协会简介", parent_label: "关于协会", children: []},
            {"value": 27, "label": "协会章程", parent_label: "关于协会", children: []},
            {"value": 28, "label": "协会领导", parent_label: "关于协会", children: []},
            {"value": 29, "label": "协会组织机构图", parent_label: "关于协会", children: []},
            {"value": 30, "label": "常务理事名单", parent_label: "关于协会", children: []},
            {"value": 31, "label": "理事名单", parent_label: "关于协会", children: []},
            {"value": 32, "label": "会员名单", parent_label: "关于协会", children: []},
            {"value": 33, "label": "协会文件", parent_label: "关于协会", children: []},
            {"value": 34, "label": "协会动态", parent_label: "关于协会", children: []}

          ]
        },
        {"value": 16, "label": "通知公告", "children": []},
        {"value": 17, "label": "工作动态", "children": []},
        {"value": 18, "label": "政策法规", "children": []},
        {
          "value": 19,
          "label": "项目信息",
          "children": [
            {"value": 35, "label": "资格预审公告", parent_label: "项目信息", children: []},
            {"value": 36, "label": "招标公告", parent_label: "项目信息", children: []},
            {"value": 37, "label": "中标候选人公示", parent_label: "项目信息", children: []},
            {"value": 38, "label": "中标结果公示", parent_label: "项目信息", children: []}
          ]
        },
        {"value": 20, "label": "行业资讯", "children": []},
        {
          "value": 21,
          "label": "会员之窗",
          "children": [
            {"value": 39, "label": "入会申请", parent_label: "行业资讯", children: []},
            {"value": 40, "label": "会员工作", parent_label: "行业资讯", children: []},
            {"value": 41, "label": "建言献策", parent_label: "行业资讯", children: []},
            {"value": 42, "label": "举报投诉", parent_label: "行业资讯", children: []},
            {"value": 43, "label": "意见反馈", parent_label: "行业资讯", children: []}
          ]
        },
        {"value": 22, "label": "学习探讨", "children": []},
        {"value": 23, "label": "时事要闻", "children": []},
        {
          "value": 51,
          "label": "大赛专题",
          "children": [
            {"value": 52, "label": "大赛通知", parent_label: "大赛专题", children: []},
            {"value": 53, "label": "大赛报道", parent_label: "大赛专题", children: []},
            {"value": 54, "label": "大赛头条", parent_label: "大赛专题", children: []},
          ]
        },
      ]
      , cur_bread: []
    }
  }
  , mounted() {
    this.index_from_uri();
  }
  , methods: {
    index_from_uri() {
      var type_id = util.parse_query().typeid;
      var rs = find(this.nav, type_id);
      if (
        rs
      ) {
        for (var k in rs) {
          var item = rs[k];
          this.cur_bread.push(item);
        }
      }
      this.$forceUpdate();
    }
  }
}
